import { createSlice } from '@reduxjs/toolkit';
import { startListening } from '../listenerMiddleware';
import { getInfo, putAtualizarInfo } from '../../services/profile';
import { TryParseUserStorage } from '../../helpers/util';
import { NotificationManager } from '../../components/react-notifications';

const initialState = {
    info: undefined,
    updated: false,
    loading: false,
    errors: [],
};

const info = TryParseUserStorage();

const profileSlice = createSlice({
    name: 'profile',
    initialState,
    reducers: {
        profileLoaded(state, action) {
            state.info = undefined;
            state.loading = true;
            state.errors = [];
        },
        profileSuccess(state, action) {
            const info = TryParseUserStorage();
            const { payload } = action;
            state.info = payload || info
            state.loading = false;
            state.errors = [];
        },
        profileError(state, action) {
            const { payload } = action;
            state.info = undefined;
            state.loading = false;
            state.errors = payload.messages
        },
        profileUpdate(state, action) {
            const { payload } = action;
            state.info = payload ?? info;
            state.loading = true;
            state.updated = false;
            state.errors = []
        },
        profileUpdated(state, action) {
            state.loading = false;
            state.updated = true;
            state.errors = [];
        },
    }
});

export const {
    profileLoaded,
    profileSuccess,
    profileError,
    profileUpdate,
    profileUpdated
} = profileSlice.actions;

export default profileSlice.reducer;

startListening({
    actionCreator: profileLoaded,
    effect: async (action, listenerApi) => {
        try {
            const response = await consultarInformacoesAsync();
            listenerApi.dispatch(profileSuccess(response));
        } catch (error) {
            listenerApi.dispatch(profileError(error.messages));
            NotificationManager.error(error.messages);
        }
    },
});

startListening({
    actionCreator: profileUpdated,
    effect: async (action, listenerApi) => {
        try {
            const response = await consultarInformacoesAsync();
            listenerApi.dispatch(profileSuccess(response));
        } catch (error) {
            listenerApi.dispatch(profileError(error.messages));
            NotificationManager.error(error);
        }
    },
});

startListening({
    actionCreator: profileUpdate,
    effect: async (action, listenerApi) => {
        const { navigate, profile } = action.payload;
        try {
            await putAtualizarInfo(profile);
            listenerApi.dispatch(profileUpdated());
            navigate(-1);
            NotificationManager.success("Cadastro atualizado.");
        } catch (error) {
            listenerApi.dispatch(profileError(error.messages));
            NotificationManager.error(error);
        }
    },
});

const consultarInformacoesAsync = async () =>
    await getInfo()
        .catch(({ messages }) => Promise.reject({ error: messages[0] }));
